import * as ava3_menu from "./ava3_menu.js";
import * as darm_menu from "./darm_menu.js";
import * as toyota_menu from "./toyota_menu.js";
import { handHygieneLabels } from '../../screens/_label/hand_hygiene/hand_hygiene_labels.js';
import { LoginScreenLabels } from "../../screens/_label/login/login_screen_labels.js";
import { UsersGroupsSearchScreenLabels } from "../../screens/_label/user_groups/usersgroups_search_screen_labels.js";
import { UserProfileScreenLabels } from "../../screens/_label/user_groups/user_profile_screen_labels.js";
import { VocsEditorScreenLabels } from "../../screens/_label/system/vocs_editor_screen_labels.js";
import { RequirementsScreenLabels } from "../../screens/_label/system/requirements_screen_labels.js";
import { BusinessUnitsScreenLabels } from "../../screens/_label/business_units/business_units_screen_labels.js";
import { ActivitiesLabels } from "../../screens/_label/activities/activities_labels.js";
import { EvaluationLabels } from "../../screens/_label/evaluation/evaluation_labels.js";
import { DashboardLabels } from "../../screens/_label/dashboard/dashboard_labels.js";
import { SystemLabels } from "../../screens/_label/system/system_labels.js";
import { FlowLabels } from "../../screens/_label/flow/flow_labels.js";
import { MeetLabels } from "../../screens/_label/meet/meet_labels.js";
import { QueueManagerLabels } from "../../screens/_label/queue_manager/queue_manager_labels.js";
import { dmsLabels } from '../../screens/_label/dms/dms_labels.js';
import { formBuilderLabels } from "../../screens/_label/form_builder/form_builder_labels.js";
import { ServiceScreenLabels } from "../../screens/_label/service_screen/service_screen_labels.js";
import { AIEditorLabels } from "../../screens/_label/ai_editor/ai_editor_labels.js";
import { ImportLabels } from "../../screens/_label/import_labels/import_labels.js";


const application_profile =
    process.env.REACT_APP_PROFILE ||
    "AIPLAN";

const write_user = ({ user }) => {
    switch (application_profile) {
        case "DARM":
            return darm_menu.write_user({ user });
        case "TOYOTA":
            return toyota_menu.write_user({ user });
        default:
            return ava3_menu.write_user({ user });
    }
};

const write = ({ user }) => {
    let menu;
    switch (application_profile) {
        case "DARM":
            menu = darm_menu.write({ user });
            break;
        case "TOYOTA":
            menu = toyota_menu.write({ user });
            break;
        default:
            menu = ava3_menu.write({ user });
            break;
    }
    GetAllLabels();
    return menu;
};

// Get i18n and t from the appropriate menu
const getI18n = () => {
    let menu;
    switch (application_profile) {
        case "DARM":
            menu = darm_menu.i18n;
            break;
        case "TOYOTA":
            menu = toyota_menu.i18n;
            break;
        default:
            menu = ava3_menu.i18n;
            break;
    }
    return menu;
};

const GetAllLabels = () => {
    const i18n = getI18n();

    i18n.addResourceBundle('it', 'labels', handHygieneLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', handHygieneLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', LoginScreenLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', LoginScreenLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', UsersGroupsSearchScreenLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', UsersGroupsSearchScreenLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', UserProfileScreenLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', UserProfileScreenLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', VocsEditorScreenLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', VocsEditorScreenLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', RequirementsScreenLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', RequirementsScreenLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', BusinessUnitsScreenLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', BusinessUnitsScreenLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', ActivitiesLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', ActivitiesLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', EvaluationLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', EvaluationLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', DashboardLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', DashboardLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', SystemLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', SystemLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', FlowLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', FlowLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', MeetLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', MeetLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', QueueManagerLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', QueueManagerLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', formBuilderLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', formBuilderLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', dmsLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', dmsLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', ServiceScreenLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', ServiceScreenLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', AIEditorLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', AIEditorLabels.en, true, true);
    i18n.addResourceBundle('it', 'labels', ImportLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', ImportLabels.en, true, true);

}

const getT = () => {
    switch (application_profile) {
        case "DARM":
            return darm_menu.t;
        case "TOYOTA":
            return toyota_menu.t;
        default:
            return ava3_menu.t;
    }
};

export { write, write_user, getI18n, getT };